import { render, staticRenderFns } from "./artifact.vue?vue&type=template&id=63b390ad&scoped=true"
import script from "./artifact.vue?vue&type=script&lang=js"
export * from "./artifact.vue?vue&type=script&lang=js"
import style0 from "./artifact.vue?vue&type=style&index=0&id=63b390ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b390ad",
  null
  
)

export default component.exports